/**
 * Social Module
 *
 * @version 1.0
 * @module core/modules/social
 *
 * @description
 * Módulo de Equipamiento Social: escuelas, hospitales, centros comunitarios.
 * Auto-registro en el moduleRegistry al importarse.
 */

import { moduleRegistry } from '../../module-registry';
import { SocialTabbedPanel } from './SocialTabbedPanel';

export { SocialTabbedPanel };

/* ===== AUTO-REGISTRO DEL MÓDULO ===== */

moduleRegistry.register({
  id: 'social',
  leftPanel: SocialTabbedPanel,
  enabledByDefault: false,
});
